import React from 'react';

function About() {
  return (
    <div className="content">
      <div className="bio">
        <p>
          Against the backdrop of an immense cultural shift in the 1960s and ’70s, <bold className="bold">"Beaujolais in my Blood.  Growing up Gay and Well-Fed in a Family-Run French Restaurant"</bold> is the poignant memoir of a home-made enterprise, told through the perspective of a disgruntled, closeted teenager.
        </p>
        <p>
          From Eric's early memories of a childhood in Berkeley, CA, these are vignettes observing his parents’ initial concept to begin a restaurant, a move to the Victorian village of Mendocino, discovering his own true nature, and uncovering a long held family secret.
        </p>
        <p>
          Written as a love letter to his wildly eccentric parents, and his own younger self, this is a memoir rich in detail, dark and funny in turns, with a reverence for the creative (and sometimes messy) human spirit. While being a very personal and transportive time capsule, this story can also be universal in its appeal.
        </p>
        <p>
          The audience for this book is anyone who may appreciate nostalgia for regional history, delight in good food, and an expression of theatrical sentiment. This story is for those who’ve struggled with identity, acceptance, advocacy or addiction, have an ear for witty observation and the resilience it takes to survive.
        </p>
        <p>
          <bold className="bold">"Beaujolais in my Blood.  Growing up Gay and Well-Fed in a Family-Run French Restaurant"</bold> is the nostalgic, bittersweet, transformational origin story of Mendocino's landmark restaurant <bold className="bold">Cafe Beaujolais</bold>.
        </p>
      </div>
    </div>
  )

}

export default About;